
import LangSwitcher from './LangSwitcher.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace, Action } from 'vuex-class';
import { createForUser } from '@license-manager/casl-rules';
import { Ability } from '@casl/ability';
import VersionInfo from './Versioninfo.vue';

const user = namespace('user');

@Component({
  components: { LangSwitcher, VersionInfo },
  name: 'TopMenuBar',
})
export default class TopMenuBar extends Vue {
  @user.Action('logout') logoutStore: () => void;

  @Prop(String)
  title: string;

  @Prop(Boolean)
  showMenu: boolean;

  @Prop(Boolean)
  showBackButton: boolean;

  @Prop(Boolean)
  showRightMenu: boolean;

  @Prop(String)
  backRouteName: string;

  @user.Getter
  CASLUser;

  public logout() {
    this.logoutStore();
    this.$ability.update(new Ability().rules);
    this.$router.push({ name: 'login' });
  }
}
